import { render, staticRenderFns } from "./UsernameRecovered.vue?vue&type=template&id=d33611bc&scoped=true&"
import script from "./UsernameRecovered.vue?vue&type=script&lang=ts&"
export * from "./UsernameRecovered.vue?vue&type=script&lang=ts&"
import style0 from "./UsernameRecovered.vue?vue&type=style&index=0&id=d33611bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33611bc",
  null
  
)

export default component.exports